import React, { useRef, useEffect } from'react';
import * as echarts from 'echarts';

const ScorePieChart = ({ chartData, title = '分组占比情况', width = '500px', height = '400px' }) => {
    const chartRef = useRef(null);
    const hasData = chartData && chartData.length > 0;

    useEffect(() => {
        if (!hasData) return;

        const myChart = echarts.init(chartRef.current);

        const option = {
            title: {
                text: title,
                left: 'left'
            },
            tooltip: {
                trigger: "item",
                formatter: "{b}：{d}%"
            },
            series: [
                {
                    type: "pie",
                    center: ["50%", "50%"],
                    radius: ["30%", "55%"],
                    clockwise: true,
                    avoidLabelOverlap: true,
                    hoverOffset: 15,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                const colorList = [
                                    "#F8A418",
                                    "#A7D56A",
                                    "#3984E1",
                                ];
                                return colorList[params.dataIndex];
                            },
                        },
                    },
                    label: {
                        show: true,
                        position: "outside",
                        formatter: "{b}：{d}%",
                    },
                    labelLine: {
                        normal: {
                            length: 15,
                            length2: 30,
                            lineStyle: {
                                width: 1,
                            },
                        },
                    },
                    data: chartData,
                },
            ],
        };

        myChart.setOption(option);

        const resizeHandler = () => myChart.resize();
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
            myChart.dispose();
        };
    }, [chartData, hasData, title, width, height]);

    return (
        hasData && (
            <div
                ref={chartRef}
                style={{ width, height }}
            />
        )
    );
};

export default ScorePieChart;